var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import Errors from './errors';
var Form = /** @class */ (function () {
    function Form(config) {
        this.config = config;
        this.errors = new Errors();
        this.onSubmit = config.onSubmit;
        this.formGroups = config.formGroups;
        this.applyValues();
    }
    Form.prototype.applyValues = function () {
        var values = this.config.values;
        if (!values) {
            return;
        }
        var elements = this.getElements();
        elements.map(function (element) {
            if (!values.hasOwnProperty(element.name)) {
                return;
            }
            var value = values[element.name];
            if (undefined === value || null === value) {
                return;
            }
            element.setValue('number' === typeof value ? value.toString() : value);
        });
    };
    Form.prototype.getError = function (key) {
        if (!this.errors) {
            return null;
        }
        return this.errors.get(key);
    };
    Form.prototype.hasError = function (key) {
        if (!this.errors) {
            return false;
        }
        return this.errors.has(key);
    };
    Form.prototype.getValues = function () {
        var elements = this.getVisibleElements();
        var values = {};
        elements.map(function (item) {
            var _a;
            return values = __assign(__assign({}, values), (_a = {}, _a[item.name] = item.getValue(), _a));
        });
        return values;
    };
    Form.prototype.getValue = function (key) {
        var elements = this.getElements();
        var element = elements.find(function (item) { return item.name === key; });
        if (!element) {
            return null;
        }
        return element.getValue();
    };
    Form.prototype.getAllValues = function () {
        var elements = this.getElements();
        var values = {};
        elements.map(function (item) {
            var _a;
            return values = __assign(__assign({}, values), (_a = {}, _a[item.name] = item.getValue(), _a));
        });
        return values;
    };
    Form.prototype.getElements = function () {
        var elements = [];
        this.formGroups.map(function (item) { return elements = __spreadArray(__spreadArray([], elements), item.getElements()); });
        return elements;
    };
    Form.prototype.getVisibleElements = function () {
        var values = this.getAllValues();
        var elements = [];
        this.formGroups.map(function (item) {
            if (!item.shouldRender(values)) {
                return;
            }
            var visibleElements = item.getVisibleElements(values);
            if (!visibleElements) {
                return;
            }
            elements = __spreadArray(__spreadArray([], elements), visibleElements);
        });
        return elements;
    };
    Form.prototype.setErrors = function (errors) {
        this.errors = errors;
    };
    return Form;
}());
export default Form;
